import React from "react";

export function Button({ label, onClick }) {
  const style = {
    padding: "15px 30px",
    fontSize: "18px",
    color: "#ffffff",
    backgroundColor: "#00c9a7",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
    transition: "background-color 0.3s, transform 0.2s",
  };

  const hoverStyle = {
    backgroundColor: "#008e76",
    transform: "scale(1.05)",
  };

  const [hovered, setHovered] = React.useState(false);

  return (
    <button
      style={hovered ? { ...style, ...hoverStyle } : style}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {label}
    </button>
  );
}
